var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { addDoc, collection } from 'firebase/firestore';
import { useContext, useCallback } from 'react';
import { FirebaseAppContext, FirebaseAuthContext } from 'libs.firebase_react';
export function useJobsAck() {
    const { db } = useContext(FirebaseAppContext);
    const { userClaims, loading: loadingAuth, error: errorAuth } = useContext(FirebaseAuthContext);
    const entityId = userClaims === null || userClaims === void 0 ? void 0 : userClaims.entityId;
    const ack = useCallback((jobId) => __awaiter(this, void 0, void 0, function* () {
        if (loadingAuth || errorAuth || !db || !entityId) {
            console.error("Internal error: using the function before it's ready");
            return;
        }
        const coll = collection(db, `entities/${entityId}/jobs/${jobId}/ack`);
        yield addDoc(coll, {});
    }), [loadingAuth, errorAuth, db, entityId]);
    return ack;
}
//# sourceMappingURL=use_jobs_ack.hook.js.map